module.exports = __webpack_public_path__ + "img/whatsapp.d5124db0.png";